import React, { createContext, useContext, useState } from 'react';

interface ErrorMessagesContextProps {
    errorMessages: string[];
    setErrorMessages: React.Dispatch<React.SetStateAction<string[]>>;
}

const ErrorMessagesContext = createContext<ErrorMessagesContextProps | undefined>(undefined);

export const ErrorMessagesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [errorMessages, setErrorMessages] = useState<string[]>([]);

    return (
        <ErrorMessagesContext.Provider value={{ errorMessages, setErrorMessages }}>
            {children}
        </ErrorMessagesContext.Provider>
    );
};

export const useErrorMessages = (): ErrorMessagesContextProps => {
    const context = useContext(ErrorMessagesContext);
    if (!context) {
        throw new Error('useErrorMessages must be used within an ErrorMessagesProvider');
    }
    return context;
};
